import React from 'react'

// material-ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

// brand
import { useBrand } from 'components/shared/SettingsProvider'
import BrandLogo from 'components/shared/BrandLogo'

const DesktopHeader = props => {
  const { title, variant } = props

  // get brand logo
  const { id } = useBrand()

  // get header background and text colors
  const theme = useTheme()
  const bgcolor = theme.components.DesktopHeader?.Box?.bgcolor || 'black'
  const color = theme.components.DesktopHeader?.Typography?.color || 'white'

  return (
    <Box width='100%' height='11rem' mb='.5rem' color='white' bgcolor={bgcolor}>
      <BrandLogo
        brand={id}
        sx={{
          position: 'absolute',
          ml: { sm: '2rem', md: '4rem' },
          mt: '1rem',
          width: '25%',
          maxWidth: { sm: '140px', md: '180px' }
        }}
      />

      <Typography
        maxWidth='50%'
        pt={8}
        mx='auto'
        align='center'
        color={color}
        variant={variant || 'h1'}
      >
        {title}
      </Typography>
    </Box>
  )
}

export default DesktopHeader
